"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Constant = require("../Constant");

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  padding: 12px 16px;\n  width: 100%;\n  list-style: none;\n  cursor: pointer;\n  font-size: 1.2rem;\n  font-weight: 700;\n\n  /* Overridden on hover */\n  color: ", ";\n  background-color: ", ";\n\n  &:hover {\n    color: ", ";\n    background: ", ";\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  margin: 0;\n  padding: 0;\n  min-width: 170px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  position: fixed;\n  display: ", ";\n  z-index: 1000;\n  top: ", "px;\n  left: ", "px;\n  box-shadow: -10px 10px 0px rgba(0, 0, 0, 0.14);\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Container = _styledComponents.default.div(_templateObject(), function (_ref) {
  var open = _ref.open;
  return open ? 'block' : 'none';
}, function (_ref2) {
  var y = _ref2.y;
  return y;
}, function (_ref3) {
  var x = _ref3.x;
  return x;
});

var Ul = _styledComponents.default.ul(_templateObject2());

var Li = _styledComponents.default.li(_templateObject3(), _Constant.Color.PURPLE, _Constant.Color.GREY_2, _Constant.Color.WHITE, _Constant.Color.PURPLE);

var ContextMenu = function ContextMenu(_ref4) {
  var items = _ref4.items,
      open = _ref4.open,
      x = _ref4.x,
      y = _ref4.y;
  return /*#__PURE__*/_react.default.createElement(Container, {
    open: open,
    x: x,
    y: y,
    "data-testid": "context-menu"
  }, /*#__PURE__*/_react.default.createElement(Ul, null, items.map(function (item) {
    return /*#__PURE__*/_react.default.createElement(Li, {
      key: item.key,
      onClick: item.onClick
    }, item.label);
  })));
};

ContextMenu.propTypes = {
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    key: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired,
    onClick: _propTypes.default.func.isRequired
  })).isRequired,
  open: _propTypes.default.bool.isRequired,
  x: _propTypes.default.number.isRequired,
  y: _propTypes.default.number.isRequired
};
var _default = ContextMenu;
exports.default = _default;